var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.622,
    height: 102.413,
    viewBox: "0 0 88.622 102.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(-181.5 -3059.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 45,
    transform: "translate(196.5 3105.5)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 45,
    transform: "translate(196.5 3119.5)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 39.777,
    transform: "translate(196.294 3132.913)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 24,
    transform: "translate(196.5 3146.5)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 25,
    transform: "translate(216.5 3091.5)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M197.5,3060.5v15.517a5.174,5.174,0,0,0,5.172,5.173H218.19",
    transform: "translate(36.724 0)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 10.938,
    y2: 10.938,
    transform: "translate(257.769 3149.561)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M254.914,3127.931v-46.745l-20.69-20.686H187.672a5.171,5.171,0,0,0-5.172,5.169v89.658a5.175,5.175,0,0,0,5.172,5.173h62.069a5.173,5.173,0,0,0,5.172-5.173v-3.638",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(234.5 3126.5)",
    fill: "none",
    stroke: "#172f86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.f062684fe53c6f4ab411d7648fad5ef6.svg";
export { ForwardRef as ReactComponent };